import { gql } from "@apollo/client";

export const RegisterUser = gql`
  mutation signupByPhoneNumber($input: SignUpRequest!) {
    signupByPhoneNumber(input: $input)
  }
`;

export const LoginUser = gql`
  mutation loginUser($input: LoginRequest!) {
    login(input: $input) {
      access_expiry
      access_token
      refresh_expiry
      refresh_token
      user {
        first_name
        last_name
      }
    }
  }
`;

export const VerifyPhone = gql`
  mutation verifyPhone($otp: String!, $phone: String!) {
    verifyPhone(otp: $otp, phone: $phone) {
      access_expiry
      access_token
      refresh_expiry
      refresh_token
      user {
        first_name
        id
        last_name
      }
    }
  }
`;

export const SendForgetPassword = gql`
  mutation sendForgetPassword($phone: String!) {
    sendForgetPasswordOTP(phone: $phone)
  }
`;

export const ResendVerifyPhoneOTP = gql`
  mutation resendVerifyPhoneOTP($phone: String!) {
    resendVerifyPhoneOTP(phone: $phone)
  }
`;

export const AddEventPart = gql`
  mutation addEventPart($input: AddEventPartRequest!) {
    addEventPart(input: $input) {
      id
      event_id
      time
      part
      name
      address
      geo_position {
        geo_position_id
        latitude
        longitude
      }
    }
  }
`;

export const UpgradeToLuxe = gql`
  mutation UpgradeToLuxe($eventId: UUID!) {
    upgradeToLuxe(eventID: $eventId)
  }
`;

export const SetPassImage = gql`
  mutation SetPassImage($eventId: UUID!, $image: String!) {
    setPassImage(event_id: $eventId, image: $image)
  }
`;

export const UpdateEventPreference = gql`
  mutation UpdateEventPreference($input: UpdateEventPreferenceRequest) {
    updateEventPreference(input: $input) {
      id
      event_id
      access_control
    }
  }
`;

export const EditEventPart = gql`
  mutation updateEventPart($input: UpdateEventPartRequest!) {
    updateEventPart(input: $input) {
      id
      event_id
      time
      part
      name
      address
      geo_position {
        geo_position_id
        latitude
        longitude
      }
    }
  }
`;

export const DeleteEventPart = gql`
  mutation deleteEventPart($eventId: Int!, $partId: Int!) {
    deleteEventPart(event_id: $eventId, partId: $partId)
  }
`;

export const AddEventVendor = gql`
  mutation addEventVendor($input: AddEventVendorRequest!) {
    addEventVendor(input: $input) {
      id
      instagram_handle
      event_id
      role
      email
      name
      phone_number
      created_at
      updated_at
    }
  }
`;

export const UpdateEventVendor = gql`
  mutation updateEventVendor($input: UpdateEventVendorRequest!) {
    updateEventVendor(input: $input) {
      id
      image
      instagram_handle
      name
      role
      event_id
      phone_number
    }
  }
`;

export const DeleteEventVendor = gql`
  mutation removeEventVendor($eventId: Int!, $vendorId: Int!) {
    removeEventVendor(event_id: $eventId, vendorId: $vendorId)
  }
`;

export const CreateGuestCategory = gql`
  mutation createGuestCategory($event_id: Int!, $name: String!) {
    createGuestCategory(event_id: $event_id, name: $name) {
      id
      event_id
      name
      created_at
      updated_at
    }
  }
`;

export const UpdateGuestCategory = gql`
  mutation updateGuestCategory(
    $eventId: Int!
    $categoryId: Int!
    $name: String!
    $message: String
  ) {
    updateGuestCategory(
      event_id: $eventId
      categoryId: $categoryId
      name: $name
      message: $message
    ) {
      id
      event_id
      name
      message
    }
  }
`;

export const CreateMessage = gql`
  mutation createMessage($eventId: Int!, $content: String!) {
    createMessage(event_id: $eventId, content: $content)
  }
`;

export const ReplyMessage = gql`
  mutation replyMessage($eventId: Int!, $messageId: Int!, $reply: String!) {
    replyMessage(event_id: $eventId, message_id: $messageId, reply: $reply)
  }
`;

export const AddToInviteList = gql`
  mutation addToInviteList(
    $eventId: Int!
    $invite_list: [AddToInviteListReq!]!
  ) {
    addToInviteList(event_id: $eventId, invite_list: $invite_list) {
      id
      uuid
      event_id
      event_uuid
      first_name
      other_name
      last_name
      title
      phone
      email

      sent
      category_id
      category {
        id
        event_id
        name
        message
        created_at
        updated_at
      }
      slots
      rsvp_status
      created_at
      updated_at
    }
  }
`;
export const DeleteGuest = gql`
  mutation removeFromInvitationList(
    $event_id: Int!
    $invitation_list_ids: [Int!]!
  ) {
    removeFromInvitationList(
      event_id: $event_id
      invitation_list_ids: $invitation_list_ids
    )
  }
`;
export const UpdateInviteList = gql`
  mutation updateInviteList(
    $eventId: Int!
    $invite_list: [UpdateInviteListReq!]!
  ) {
    updateInviteList(event_id: $eventId, invite_list: $invite_list)
  }
`;

export const AddBackStories = gql`
  mutation addBackStory($eventId: Int!, $input: addBackStoryReq!) {
    addBackStory(event_id: $eventId, input: $input) {
      title
      id
      event_id
      role
      story
      image
    }
  }
`;

export const UpdateBackStories = gql`
  mutation updateBackStory($eventId: Int!, $input: updateBackStoryReq!) {
    updateBackStory(event_id: $eventId, input: $input) {
      title
      id
      event_id
      role
      story
    }
  }
`;

export const DeleteBackStories = gql`
  mutation deleteBackStory($eventId: Int!, $id: Int!) {
    deleteBackStory(event_id: $eventId, id: $id)
  }
`;

export const AddWishlistItem = gql`
  mutation addWishListItem(
    $eventId: Int!
    $name: String!
    $image: String!
    $amount: Float!
    $currency: Currency
  ) {
    addWishListItem(
      event_id: $eventId
      name: $name
      image: $image
      amount: $amount
      currency: $currency
    ) {
      id
      name
      image
      amount
    }
  }
`;

export const UpdateWishlistItem = gql`
  mutation updateWishListItem(
    $eventId: Int!
    $itemId: Int!
    $name: String!
    $image: String!
    $amount: Float!
    $currency: Currency
  ) {
    updateWishListItem(
      event_id: $eventId
      itemId: $itemId
      name: $name
      image: $image
      amount: $amount
      currency: $currency
    ) {
      id
      wish_list_id
      name
      image
      amount
    }
  }
`;

export const DeleteWishlistItem = gql`
  mutation deleteWishListItem($eventId: Int!, $itemId: Int!) {
    deleteWishListItem(event_id: $eventId, itemId: $itemId)
  }
`;

export const PayForCashGiftV1 = gql`
  mutation payForCashGiftV1($payload: payForCashGiftRequest!) {
    payForCashGiftV1(payload: $payload)
  }
`;

export const PayForWishListItemV1 = gql`
  mutation payForWishListItemV1($payload: payForWishlistItemRequest!) {
    payForWishListItemV1(payload: $payload)
  }
`;

export const CreateAlbum = gql`
  mutation createAlbum($eventId: UUID!, $name: String!, $description: String) {
    createAlbum(event_id: $eventId, name: $name, description: $description) {
      id
      name
      description
    }
  }
`;

export const AddMedia = gql`
  mutation addMedia($eventId: UUID!, $url: String!, $tags: [AlbumMediaTag!]!) {
    addMedia(event_id: $eventId, url: $url, tags: $tags) {
      id
      name
      url
      tags
      type
      meta {
        s3_url
        height
        width
      }
      created_at
      updated_at
    }
  }
`;

export const AddMediaToAlbum = gql`
  mutation AddMediaToAlbum(
    $eventId: UUID!
    $albumId: UUID!
    $mediaIds: [String!]!
    $tags: [AlbumMediaTag!]
  ) {
    addMediaToAlbum(
      event_id: $eventId
      album_id: $albumId
      media_ids: $mediaIds
      tags: $tags
    )
  }
`;

export const BulkDeleteMedia = gql`
  mutation BulkDeleteMedia($eventId: UUID!, $mediaId: UUID!) {
    bulkDeleteMedia(event_id: $eventId, media_id: $mediaId)
  }
`;

export const DeleteMedia = gql`
  mutation deleteMedia($eventId: UUID!, $mediaId: UUID!) {
    deleteMedia(event_id: $eventId, media_id: $mediaId)
  }
`;
export const DeleteAlbum = gql`
  mutation deleteAlbum($eventId: UUID!, $albumId: UUID!) {
    deleteAlbum(event_id: $eventId, album_id: $albumId)
  }
`;

export const DeleteGuestCategory = gql`
  mutation deleteGuestCategory($event_id: Int!, $categoryId: Int!) {
    deleteGuestCategory(event_id: $event_id, categoryId: $categoryId)
  }
`;

export const GetGiftHistory = gql`
  query getGiftHistory($event_id: UUID!, $cursor: String, $page_size: Int) {
    getGiftHistory(
      event_id: $event_id
      cursor: $cursor
      page_size: $page_size
    ) {
      meta {
        next
        back
      }
      gifts {
        amount
        creditor_alias
        currency_iso
        event_id
        fee
        id
        narration
        note
        payment_provider
        payment_provider_reference
        total_amount
        wallet_id
        wish_list_item_id
      }
    }
  }
`;

// export const GetGiftHistoryV2 = gql`
//   query getGiftHistoryV2($eventId: Int!, $pageSize: Int, $page: Int!) {
//     getGiftHistoryV2(event_id: $eventId, pageSize: $pageSize, page: $page) {
//       transactionId
//       user {
//         full_name
//         email
//         phone_number
//       }
//       currency
//       amount
//       appreciated
//       walletId
//       gift {
//         transactionId
//         name
//         gift_type
//       }
//     }
//   }
// `;

export const GetWishlistHistory = gql`
  query getWishlistHistory($event_id: UUID!, $page_size: Int, $page: Int!) {
    getWishlistHistory(
      event_id: $event_id
      page_size: $page_size
      page: $page
    ) {
      amount
      appreciated
      currency
      gift_id
      user {
        full_name
        email
        phone_number
        user_id
      }
      wallet_id
      wish_list_item {
        amount
        appreciation
        currency
        event_id
        image
        name
        paid
        qty
        user {
          email
          first_name
          last_name
          guest
        }
        uuid
        wish_list_id
      }
      wish_list_item_id
    }
  }
`;

export const CreateAppreciation = gql`
  mutation appreciateGift(
    $eventId: Int!
    $walletId: String!
    $transactionId: String!
    $appreciation: String!
  ) {
    appreciateGift(
      event_id: $eventId
      walletId: $walletId
      transactionId: $transactionId
      appreciation: $appreciation
    )
  }
`;

export const CreateEvent = gql`
  mutation createEvent(
    $name: String!
    $eventTypeId: Int!
    $role: String
    $hashTag: String
  ) {
    createEvent(
      name: $name
      event_type_id: $eventTypeId
      role: $role
      hashTag: $hashTag
    ) {
      id
      name
      created_at
      updated_at
      event_owners {
        id
        user_id
        user {
          first_name
          last_name
        }
        event_id
        admin
        created_at
        updated_at
      }
      event_type {
        id
        name
        description
      }
    }
  }
`;

export const UpdateEvent = gql`
  mutation updateEvent(
    $eventId: Int!
    $name: String
    $hashTag: String
    $welcomeMsg: String
  ) {
    updateEvent(
      event_id: $eventId
      name: $name
      hashTag: $hashTag
      welcomeMsg: $welcomeMsg
    ) {
      id
      name
      welcome_msg
      hash_tag
    }
  }
`;

export const DeleteEvent = gql`
  mutation deleteEvent($eventId: Int!) {
    deleteEvent(event_id: $eventId)
  }
`;

export const ResetPassword = gql`
  mutation resetPassword($otp: String!, $password: String!, $phone: String!) {
    resetPassword(OTP: $otp, password: $password, phone: $phone)
  }
`;

export const UpdateUserProfile = gql`
  mutation updateUserProfile($input: UpdateUserProfileRequest!) {
    updateUserProfile(input: $input) {
      id
      title
      first_name
      last_name
      other_name
    }
  }
`;

export const UpdateInvitationCard = gql`
  mutation updateInvitationCard($eventId: Int!, $template: String!) {
    updateInvitationCard(event_id: $eventId, template: $template) {
      id
      event_id
      template
      updated_at
      created_at
    }
  }
`;

export const UpdateChangePassword = gql`
  mutation changePassword($newPassword: String!, $oldPassword: String!) {
    changePassword(newPassword: $newPassword, oldPassword: $oldPassword)
  }
`;

export const UpdateEventSlug = gql`
  mutation updateEventSlug($eventId: Int!, $slug: String!) {
    updateEventSlug(event_id: $eventId, slug: $slug) {
      id
      name
      hash_tag
      slug
      welcome_msg
      created_at
      updated_at
    }
  }
`;

export const EditEvent = gql`
  mutation editEvent(
    $eventId: Int!
    $slug: String!
    $updateEventEventId2: Int!
    $name: String
    $hashTag: String
    $welcomeMsg: String
  ) {
    updateEventSlug(event_id: $eventId, slug: $slug) {
      id
      name
      slug
      welcome_msg
    }
    updateEvent(
      event_id: $updateEventEventId2
      name: $name
      hashTag: $hashTag
      welcomeMsg: $welcomeMsg
    ) {
      id
      name
      hash_tag
      welcome_msg
    }
  }
`;
export const DeleteMessageById = gql`
  mutation deleteMessageById($eventId: Int!, $messageId: Int!) {
    deleteMessageById(event_id: $eventId, message_id: $messageId)
  }
`;

export const TransferToBank = gql`
  mutation transferToBank($input: transferFromWalletRequest) {
    transferToBank(input: $input) {
      status
      otp_is_required
    }
  }
`;

export const CreateMultipleGuestCategories = gql`
  mutation createMultipleGuestCategories($eventId: Int!, $names: [String!]) {
    createMultipleGuestCategories(event_id: $eventId, names: $names) {
      id
      event_id
      name
      created_at
      updated_at
    }
  }
`;

export const SendInvitations = gql`
  mutation sendInvitations($eventId: UUID!, $req: SendInviteReq!) {
    sendInvitations(event_id: $eventId, req: $req) {
      channel
      status {
        id
        error
      }
    }
  }
`;

export const UpdateRsvpStatus = gql`
  mutation updateRsvpStatus($eventId: Int!, $status: String!) {
    updateRsvpStatus(event_id: $eventId, status: $status)
  }
`;

export const VerifyTransaction = gql`
  mutation verifyTransaction($reference: String!) {
    verifyTransaction(reference: $reference) {
      id
      reference
      payment_processor
      event_uuid
      event_id
      user_uuid
      full_name
      currency
      amount
      status
      stage
      kind
    }
  }
`;

export const GetMediaPresignedUrl = gql`
  mutation GetMediaPresignedUrl($event_id: UUID!, $mediaType: String!) {
    getMediaPresignedUrl(event_id: $event_id, mediaType: $mediaType) {
      upload_url
      file_uri
      thumbnail_uri
      expiry_time
      expiry_time_in_seconds
      event_id
      media_id
    }
  }
`;

export const GenerateBackstoryPresignedUrl = gql`
  mutation GenerateBackstoryPresignedUrl(
    $event_id: UUID!
    $mediaType: String!
  ) {
    generateBackstoryPresignedUrl(event_id: $event_id, mediaType: $mediaType) {
      upload_url
      file_uri
      expiry_time
      expiry_time_in_seconds
      event_id
    }
  }
`;

export const VerifyMediaUpload = gql`
  mutation VerifyMediaUpload(
    $event_id: UUID!
    $url: String!
    $tags: [AlbumMediaTag!]!
  ) {
    verifyMediaUpload(event_id: $event_id, url: $url, tags: $tags)
  }
`;

export const GetInvitationSelfiePresignedUrl = gql`
  mutation Mutation(
    $eventId: UUID!
    $invitationId: UUID!
    $mediaType: String!
  ) {
    generateInvitationSelfiePreSignedUrl(
      event_id: $eventId
      invitation_id: $invitationId
      mediaType: $mediaType
    ) {
      file_uri
      invitation_id
      upload_url
      event_id
      expiry_time
      expiry_time_in_seconds
    }
  }
`;

export const VerifyInvitationSelfieUpload = gql`
  mutation VerifyInvitationSelfieUpload(
    $eventId: UUID!
    $invitationId: UUID!
    $fileUri: String!
  ) {
    verifyInvitationSelfieUpload(
      event_id: $eventId
      invitation_id: $invitationId
      fileUri: $fileUri
    )
  }
`;

export const AutoSendInawoPass = gql`
  mutation AutoSendInawoPass($eventId: UUID!) {
    autoSendInawoPass(event_id: $eventId)
  }
`;

export const ResetGeneralInviteToken = gql`
  mutation ResetGeneralInviteToken($eventId: UUID!) {
    resetGeneralInviteToken(event_id: $eventId)
  }
`;

export const SelectTemplate = gql`
  mutation SelectTemplate($req: SelectTemplateReq!) {
    selectTemplate(req: $req)
  }
`;

export const CreateAsoebiGroup = gql`
  mutation CreateAseobi($event_id: UUID!, $name: String!) {
    createAseobi(event_id: $event_id, name: $name)
  }
`;

export const UpdateAsoebiGroup = gql`
  mutation UpdateAseobi(
    $id: UUID!
    $event_id: UUID!
    $name: String
    $status: AsoebiStatus
    $description: String
  ) {
    updateAseobi(
      id: $id
      event_id: $event_id
      name: $name
      status: $status
      description: $description
    )
  }
`;

export const CreateAsoebiAttire = gql`
  mutation AddAseobiAttire($event_id: UUID!, $input: AseobiAttireInput!) {
    addAseobiAttire(event_id: $event_id, input: $input)
  }
`;

export const UpdateAsoebiAttire = gql`
  mutation UpdateAseobiAttire(
    $event_id: UUID!
    $id: UUID!
    $input: AseobiAttireInput!
  ) {
    updateAseobiAttire(event_id: $event_id, id: $id, input: $input)
  }
`;

export const GenerateAseobiAttirePresignUrl = gql`
  mutation GenerateAseobiAttirePresignUrl(
    $event_id: UUID!
    $attire_id: UUID!
    $mediaType: String!
  ) {
    generateAseobiAttirePresignUrl(
      event_id: $event_id
      attire_id: $attire_id
      mediaType: $mediaType
    ) {
      upload_url
      file_uri
      expiry_time
      expiry_time_in_seconds
      event_id
      attire_id
    }
  }
`;

export const VerifyAseobiAttireUpload = gql`
  mutation verifyAseobiAttireUpload(
    $event_id: UUID!
    $replace: Boolean!
    $attire_id: UUID!
    $fileUri: String!
  ) {
    verifyAseobiAttireUpload(
      event_id: $event_id
      replace: $replace
      attire_id: $attire_id
      fileUri: $fileUri
    )
  }
`;

export const INITIATE_KYC = gql`
  mutation InitiateKyc($currency: Currency!) {
    initiateKyc(currency: $currency) {
      eligible
      message
      widget_id
    }
  }
`;

export const UPDATE_BANK_DETAILS = gql`
  mutation UpdateUserBankDetails(
    $event_id: UUID!
    $input: UpdateBankDetailsRequest!
  ) {
    updateUserBankDetails(event_id: $event_id, input: $input)
  }
`;

export const ATTACH_ASOEBI_PAYMENT = gql`
  mutation AttachAseobiPayment(
    $event_id: UUID!
    $aseobi_id: UUID!
    $currency_iso: Currency!
  ) {
    attachAseobiPayment(
      event_id: $event_id
      aseobi_id: $aseobi_id
      currency_iso: $currency
    )
  }
`;

export const ATTACH_EVENT_WALLET_TO_SUBACCOUNT = gql`
  mutation AttachEventWalletToSubaccount(
    $event_id: UUID!
    $currency: Currency!
  ) {
    attachEventWalletToSubaccount(event_id: $event_id, currency: $currency)
  }
`;

export const GenerateLuxePaymentMetadata = gql`
  mutation generateLuxePaymentMetadata($event_id: UUID!, $currency: Currency!) {
    generateLuxePaymentMetadata(event_id: $event_id, currency: $currency) {
      amount_after_discount
      amount_before_discount
      currency_iso
      custom_fields {
        display_name
        value
        variable_name
      }
      discount_amount_applied
      discount_percentage_applied
      event_id
      full_name
      hash
      inawo_product
      payment_provider
      payment_reference
      timestamp
      user_id
    }
  }
`;

export const GenerateGiftPaymentMetadata = gql`
  mutation generateGiftPaymentMetadata($input: GiftPaymentMetadataRequest!) {
    generateGiftPaymentMetadata(input: $input) {
      custom_fields {
        display_name
        value
        variable_name
      }
      contact_email
      contact_phone_number
      currency_iso
      event_id
      full_name
      gift_id
      hash
      inawo_product
      note
      payment_provider
      payment_reference
      split_percentage
      sub_account_code
      sub_account_id
      timestamp
      user_id
      wish_list_item_id
    }
  }
`;

export const GenerateInviteFeePaymentMetadata = gql`
  mutation generateInviteFeePaymentMetadata(
    $event_id: UUID!
    $amount: Float!
    $currency: Currency!
    $channel: String!
    $count: Int!
  ) {
    generateInviteFeePaymentMetadata(
      event_id: $event_id
      amount: $amount
      currency: $currency
      channel: $channel
      count: $count
    ) {
      amount
      channel
      count
      currency_iso
      custom_fields {
        display_name
        value
        variable_name
      }
      event_id
      hash
      inawo_product
      payment_provider
      payment_reference
      user_id
    }
  }
`;

export const DeleteAsoebiAttire = gql`
  mutation DeleteAseobiAttire($event_id: UUID!, $aseobi_attire_id: UUID!) {
    deleteAseobiAttire(event_id: $event_id, aseobi_attire_id: $aseobi_attire_id)
  }
`;

export const DeleteAsoebiGroup = gql`
  mutation DeleteAseobi($event_id: UUID!, $aseobi_id: UUID!) {
    deleteAseobi(event_id: $event_id, aseobi_id: $aseobi_id)
  }
`;
